/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import DownloadDeliveryListRequest from '../model/DownloadDeliveryListRequest';
import GetDeliveryListResponse from '../model/GetDeliveryListResponse';

/**
* DeliveryLists service.
* @module api/DeliveryListsApi
* @version 2020-12-7
*/
export default class DeliveryListsApi {

    /**
    * Constructs a new DeliveryListsApi. 
    * @alias module:api/DeliveryListsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    deliveryListDownloadPreflightWithHttpInfo(groupId) {
      let postBody = null;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/delivery-lists/{groupId}/download', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    deliveryListDownloadPreflight(groupId) {
      return this.deliveryListDownloadPreflightWithHttpInfo(groupId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    deliveryListPreflightWithHttpInfo(groupId) {
      let postBody = null;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/delivery-lists/{groupId}', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    deliveryListPreflight(groupId) {
      return this.deliveryListPreflightWithHttpInfo(groupId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 印刷用配送リストを取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
    downloadDeliveryListWithHttpInfo(body, groupId) {
      let postBody = body;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/delivery-lists/{groupId}/download', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 印刷用配送リストを取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
    downloadDeliveryList(body, groupId) {
      return this.downloadDeliveryListWithHttpInfo(body, groupId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 配送リストを取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetDeliveryListResponse} and HTTP response
     */
    getDeliveryListWithHttpInfo(groupId, opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
        '_with': opts['_with']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetDeliveryListResponse;

      return this.apiClient.callApi(
        '/delivery-lists/{groupId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 配送リストを取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetDeliveryListResponse}
     */
    getDeliveryList(groupId, opts) {
      return this.getDeliveryListWithHttpInfo(groupId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }

}
